module.exports = __webpack_public_path__ + "img/ty_5.c697e0aa.png";